export const remToPixels = (rem: string) => {
  return parseFloat(rem) * parseFloat(getComputedStyle(document.documentElement).fontSize);
};
